import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { inRange } from './algorithm';
export function top(list) {
  return list[list.length - 1];
}
export function flat(list) {
  return list.reduce(function (acc, cur) {
    if (Array.isArray(cur)) {
      acc.push.apply(acc, _toConsumableArray(flat(cur)));
    } else {
      acc.push(cur);
    }

    return acc;
  }, []);
}
/**
 * 比较两个元祖
 * @param {Array<T>} lhs
 * @param {Array<T>} rhs
 * @param {(T, T)=>Number} [compare] 比较函数
 * @returns {Number} 0表示相等，大于0表示前者大，小于0表示后者大
 */

export function compareTuple(lhr, rhs) {
  var compare = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (a, b) {
    return a - b;
  };
  var i = 0;

  for (; i < lhr.length; ++i) {
    if (i in rhs) {
      var result = compare(lhr[i], rhs[i]);

      if (result !== 0) {
        return result;
      }
    } else {
      return 1;
    }
  }

  if (i in rhs) {
    return -1;
  }

  return 0;
}
/**
 * 判断元祖value是否在范围[min, max]中，前闭后闭
 * @param {Array<T>} value
 * @param {Array<T>} min
 * @param {Array<T>} max
 * @param {(T, T)=>Number} [compare] 比较函数
 * @returns {Boolean} 结果
 */

export function isTupleInRage(value, min, max, compare) {
  return inRange(function (l, r) {
    return compareTuple(l, r, compare);
  }, value, min, max);
}
/**
 * 判断两个数组是否相等
 * @param {Array} arr1
 * @param {Array} arr2
 * @returns {Boolean} 结果
 */

export function isEqual(arr1, arr2) {
  if (arr1 === arr2) {
    return true;
  }

  if (arr1.length !== arr2.length) {
    return false;
  }

  for (var i = 0; i < arr1.length; ++i) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
}
/**
 * 创建一个对象组成， key（键） 是 collection（集合）中的每个元素经过 iteratee（迭代函数） 处理后返回的结果。 每个 key（键）对应的值是生成key（键）的最后一个元素。iteratee（迭代函数）调用1个参数：(value)。
 * @param {Array} arr 用来迭代的集合
 * @param {String|Function} name 这个迭代函数用来转换key
 * @returns {Boolean} 返回一个组成聚合的对象。
 */

export function keyBy(arr, name) {
  return arr.reduce(function (total, cur) {
    return _objectSpread(_objectSpread({}, total), {}, _defineProperty({}, cur[name], cur));
  }, {});
}